export function userStatus(status) {
  switch (status) {
    case "Active": status = "正常"; break;
    case "Abnormal": status = "暂停"; break;
    case "Stop": status = "停止"; break;
    case "Deleted": status = "关闭"; break;
    default: status = "--"; break;
  }
  return status;
}

// 老班级状态配置
export const statusKV = {
  // 培训班状态
  "Edit": {
    text: "培训班未提交",
    color: '#333399'
  },
  "Audit": {
    text: "培训班审核中",
    color: '#CC3399'
  },
  "Refused": {
    text: "培训班审核拒绝",
    color: '#FF0000'
  },
  "Initiated": {
    text: "培训班未开始",
    color: '#00CCFF',
  },
  "Incomplete": {
    text: "培训班进行中",
    color: '#0066FF'
  },
  "Finalised": {
    text: "考试已结束",
    color: '#339933'
  },
  "ScoreAudit": {
    text: "成绩审核中",
    color: '#FF9900'
  },
  "ScoreRefused": {
    text: "成绩审核拒绝",
    color: '#FF0000'
  },
  "ScoreAffirm": {
    text: "成绩已确认(编号中)",
    color: '#00FF00'
  },
  "Complete": {
    text: "培训班已完成",
    color: '#00FF00'
  },
  "IsEvalua": {
    text: "已调查",
    color: '#00CC00'
  },
  "NotEvalua": {
    text: "未调查",
    color: '#FF0000'
  },
  "Through": {
    text: "已通过",
    color: '#4cd964'
  },
  // 报名状态
  "enrollEdit": {
    text: "暂时保存",
    color: '#333399'
  },
  "enrollClose": {
    text: "报名已关闭",
    color: '#FF0000'
  },
  "enrollInitiated": {
    text: "报名未开始",
    color: '#00CCFF'
  },
  "enrollIncomplete": {
    text: "报名进行中",
    color: '#0066FF'
  },
  "enrollFinalised": {
    text: "报名已结束",
    color: '#339933'
  },
  "enrollComplete": {
    text: "报名已完成",
    color: '#00FF00'
  },
  // 注册人员状态
  'personnelRefused': {
    text: '会员协会拒绝',
    color: '#FF0000'
  },
  'personnelPerfect': {
    text: '资料待完善',
    color: '#FF0000'
  },
  'personnelThrough': {
    text: '会员协会推荐',
    color: '#60C5F1'
  },
  'organThrough': {
    text: '会员协会通过',
    color: '#b4b408'
  },
  'personnelSubmitted': {
    text: '会员协会审核中',
    color: '#FF9900'
  },
  'personnelAdmit': {
    text: '中国足协已录取',
    color: '#00FF00'
  },
  'personnelEdit': {
    text: '暂时保存',
    color: '#333399'
  },
  'personnelUnadmit': {
    text: '中国足协未录取',
    color: '#FF0000'
  },
  'examPersonnel': {
    text: '补考申请待处理',
    color: '#f88594'
  },
  'examRefused': {
    text: '补考审核拒绝',
    color: '#d48265'
  },
  'examThrough': {
    text: '补考审核通过',
    color: '#4cd964'
  },
  'teacherPersonnel': {
    text: '报名申请待处理',
    color: '#f88594'
  },
  'teacherRefused': {
    text: '报名审核拒绝',
    color: '#d48265'
  },
  'teacherThrough': {
    text: '报名审核通过',
    color: '#4cd964'
  },
  'enrollCheckRefused': {
    text: '报名审核拒绝',
    color: '#d48265'
  },
  'enrollCheckThrough': {
    text: '报名审核通过',
    color: '#32B8D9'
  },
  'onlineAdmit': {
    text: '线上已录取，线下未录取',
    color: '#4cd964'
  },
  'offlineAdmit': {
    text: '线下已录取，线上未录取',
    color: '#4cd964'
  },
}

export const statusKVStudent = {
  // 报名人员状态
  'personnelRefused': {
    text: '未录取',
    color: '#FF0000'
  },
  'personnelPerfect': {
    text: '资料待完善',
    color: '#FF0000'
  },
  "enrollComplete": {
    text: "报名已完成",
    color: '#00FF00'
  },
  'personnelThrough': {
    text: '通过',
    color: '#4cd964'
  },
  'organThrough': {
    text: '通过',
    color: '#4cd964'
  },
  'personnelSubmitted': {
    text: '审核中',
    color: '#FF9900'
  },
  'personnelAdmit': {
    text: '已录取',
    color: '#00FF00'
  },
  'personnelEdit': {
    text: '暂时保存',
    color: '#333399'
  },
  'personnelUnadmit': {
    text: '未录取',
    color: '#FF0000'
  },
  'examPersonnel': {
    text: '审核中',
    color: '#f88594'
  },
  'examRefused': {
    text: '未录取',
    color: '#d48265'
  },
  // examThrough B/A 叫做 审核中   职业级叫做已录取
  'examThrough': {
    text: '审核中',
    color: '#4cd964'
  },
  'enrollCheckRefused': {
    text: '未录取',
    color: '#d48265'
  },
  'enrollCheckThrough': {
    text: '已录取',
    color: '#32B8D9'
  },
  'teacherPersonnel': {
    text: '审核中',
    color: '#f88594'
  },
  'teacherRefused': {
    text: '审核拒绝',
    color: '#d48265'
  },
  'teacherThrough': {
    text: '审核通过',
    color: '#4cd964'
  },
  'onlineAdmit': {
    text: '线上已录取，线下未录取',
    color: '#4cd964'
  },
  'offlineAdmit': {
    text: '线下已录取，线上未录取',
    color: '#4cd964'
  },
}


// 转会申请状态
export const alterationOrgStatus = {
  "Edit": {
    text: "暂时保存",
    color: '#333399'
  },
  "Initiated": {
    text: "未开始",
    color: '#00CCFF'
  },
  "CoachSubmit": {
    text: "教练员注册进行中",
    color: '#CC3399'
  },
  "EnterOrgAudit": {
    text: "转入协会审核中",
    color: '#99CCCC'
  },
  "LeaveOrgAudit": {
    text: "转出协会审核中",
    color: '#FF9966'
  },
  "Complete": {
    text: "注册变更成功",
    color: '#00FF00'
  },
  "EnterOrgFail": {
    text: "转入协会拒绝",
    color: '#FF0000'
  },
  "LeaveOrgFail": {
    text: "转出协会拒绝",
    color: '#FF6666'
  },
  "Finish": {
    text: "注册窗口已结束",
    color: '#288eff'
  },
}
// 转会申请 教练员状态 状态
export const alterationCoachStatus = {
  "EnterOrgFail": {
    text: "转入协会拒绝",
    color: '#FF0000'
  },
  "EnterOrgAudit": {
    text: "转入协会审核中",
    color: '#99CCCC'
  },

  "LeaveOrgAudit": {
    text: "转出协会审核中",
    color: '#FF9966'
  },
  "LeaveOrgFail": {
    text: "转出协会拒绝",
    color: '#FF6666'
  },

  "Complete": {
    text: "注册变更成功",
    color: '#00FF00'
  },
  "Finish": {
    text: "注册变更中",
    color: '#288eff'
  },
}
// 五人制培訓班開班申請
export  const fiveApplicationClass = {
  "edit": {
    text: "开班申请未提交",
    color: '#333399'
  },
  "audit": {
    text: "开班申请审核中",
    color: '#CC3399'
  },
  "though": {
    text: "开班申请已通过",
    color: '#32B8D9'
  },
  "refused": {
    text: "开班申请已拒绝",
    color: '#FF0000'
  },
  "complete": {
    text: "开班申请已完成",
    color: '#4cd964'
  },
}
// 帐号权限标识
export const
  superFiveAccount = 'supFive',
  systemFiveAccount = 'sysFive',
  viewFiveAccount = 'viewFive',
  organFiveAccount = 'orgFive',
  teacherFiveAccount = 'teaFive',
  studentFiveAccount = 'stuFive',
  registrationFiveAccount = 'registrationFive',
  expFive = 'expFive',

  superAccount = 'super',
  systemAccount = 'system',
  viewerAccount = 'viewer',
  organAccount = 'organ',
  studentAccount = 'student',
  teacherAccount = 'teacher',
  registrationAccount = 'registration',
  expireStudent = 'expireStudent',
  dataDisplayAccount = 'dataDisplay',
  instructorAssistantAccount = 'instructorAssistant';

export function checkIsFiveByUserType(userType) {
  let res = null;
  if (userType) {
    switch (userType) {
      case 'super':
      case 'system':
      case 'viewer':
      case 'organ':
      case 'student':
      case 'teacher':
      case 'registration':
      case 'expireStudent':
      case 'dataDisplay':
      case 'instructorAssistant':
        res = false;
        break;
      case 'supFive':
      case 'sysFive':
      case 'viewFive':
      case 'orgFive':
      case 'teaFive':
      case 'stuFive':
      case 'registrationFive':
      case 'expFive':
        res = true;
        break;
    }
  }
  return res;
}

export const roleHash = {
  [superAccount]: '技术支持(十一人制)',
  [systemAccount]: '系统管理员(十一人制)',
  [organAccount]: "机构管理员(十一人制)",
  [teacherAccount]: "讲师(十一人制)",
  [studentAccount]: "学员(十一人制)",
  [expireStudent]: "学员(十一人制)",
  [registrationAccount]: "报名用户(十一人制)",
  [viewerAccount]: "信息查看权限(十一人制)",
  [dataDisplayAccount]: "大数据展示权限",
  [instructorAssistantAccount]: "讲师助理",

  [superFiveAccount]: '技术支持(五人制)',
  [systemFiveAccount]: '系统管理员(五人制)',
  [organFiveAccount]: "机构管理员(五人制)",
  [teacherFiveAccount]: "讲师(五人制)",
  [studentFiveAccount]: "学员(五人制)",
  [expFive]: "学员(五人制)",
  [registrationFiveAccount]: "报名用户",
  [viewFiveAccount]: "信息查看权限(五人制)",
};

export const roleHashDefault = {
  [superAccount]: '技术支持',
  [systemAccount]: '系统管理员',
  [organAccount]: "机构管理员",
  [teacherAccount]: "讲师",
  [studentAccount]: "学员",
  [expireStudent]: "学员",
  [registrationAccount]: "报名用户",
  [viewerAccount]: "信息查看权限",
  [dataDisplayAccount]: "大数据展示权限",
  [instructorAssistantAccount]: "讲师助理",

  [superFiveAccount]: '技术支持',
  [systemFiveAccount]: '系统管理员',
  [organFiveAccount]: "机构管理员",
  [teacherFiveAccount]: "讲师",
  [studentFiveAccount]: "学员",
  [expFive]: "学员",
  [registrationFiveAccount]: "报名用户",
  [viewFiveAccount]: "信息查看权限",
};

export const roleType = role => roleHash[role];
export const roleTypeDefault = role => roleHashDefault[role];


//解决身份为多个的情况
export function newRoleType(role) {
  if (/super/g.test(role)) {
    return '技术支持'
  }
  else if (/organ/g.test(role)) {
    return '机构管理员'
  } else if (/system/g.test(role)) {
    return '系统管理员'
  } else if (/teacher/g.test(role)) {
    return '讲师'
  } else if (/student/g.test(role)) {
    return '学员'
  } else if (/registration/g.test(role)) {
    return '学员'
  } else if (/expireStudent/g.test(role)) {
    return '学员'
  } else if (/view/g.test(role)) {
    return '信息查看权限'
  } else if (/dataDisplay/g.test(role)) {
    return '大数据展示权限'
  }else if (/instructorAssistant/g.test(role)) {
    return '讲师助理'
  }
}

// 通知类型
export const noticeTypes = {
  'system': '系统通知'
};

/* 讲师等级 */
export function teacherLevel(level) {
  switch (level) {
    case "0": level = "亚足联/中国足协职业级讲师"; break;
    case "A": level = "亚足联/中国足协A级讲师"; break;
    case "B": level = "亚足联/中国足协B级讲师"; break;
    case "C": level = "中国足协C级讲师"; break;
    case "D": level = "中国足协D级讲师"; break;
    case "E": level = "中国足协D级助理"; break;
    case 'stamina': level = "亚足联体能讲师"; break;
    case 'goaltender': level = "亚足联守门员讲师"; break;
    default: level = "--"; break;
  }
  return level;
}


/* 教练员等级 */
export function colLevel(level) {
  switch (level) {
    // 十一人制
    case "0": level = "亚足联/中国足协职业级教练员"; break;
    case "A": level = "亚足联/中国足协A级教练员"; break;
    case "B": level = "中国足协B级教练员"; break;
    case "C": level = "中国足协C级教练员"; break;
    case "D": level = "中国足协D级教练员"; break;
    case "G-L1": level = "亚足联守门员教练L1"; break;
    case "G-L2": level = "亚足联守门员教练L2"; break;
    case "G-L3": level = "亚足联守门员教练L3"; break;
    case "S-L1": level = "亚足联体能教练L1"; break;
    case "S-L2": level = "亚足联体能教练L2"; break;
    // 五人制
    case "L3": level = "亚足联/中国足协五人制L3级教练员"; break;
    case "L2": level = "亚足联/中国足协五人制L2级教练员"; break;
    case "L1": level = "亚足联/中国足协五人制L1级教练员"; break;
    case "early": level = "中国足协五人制初级教练员"; break;
    case "GF-L1": level = "亚足联五人制守门员教练L1"; break;
    case "GF-L2": level = "亚足联五人制守门员教练L2"; break;
    case "GF-L3": level = "亚足联五人制守门员教练L3"; break;
    case "SF-L1": level = "亚足联五人制体能教练L1"; break;
    case "SF-L2": level = "亚足联五人制体能教练L2"; break;
    default: level = "--"; break;
  }
  return level;
}
// 通知页面的 接收用户类型
export const roleHashNotice = {
  // [superAccount]: '技术支持',
  // [systemAccount]: '系统管理员',
  // [organAccount]: "机构管理员",
  // [teacherAccount]: "所有讲师",
  // [studentAccount]: "学员",

  [superAccount]: '技术支持(十一人制)',
  [systemAccount]: '系统管理员(十一人制)',
  [organAccount]: "机构管理员(十一人制)",
  [teacherAccount]: "讲师(十一人制)",
  [studentAccount]: "学员(十一人制)",

  [superFiveAccount]: '技术支持(五人制)',
  [systemFiveAccount]: '系统管理员(五人制)',
  [organFiveAccount]: "机构管理员(五人制)",
  [teacherFiveAccount]: "讲师(五人制)",
  [studentFiveAccount]: "学员(五人制)",
};

// 培训班等级
export function classLevel(level) {
  // if (level === "Pro" || level === "PRO") level = "职业";
  // if (level === "E") level = "D级助理";
  // return level;
  let res = '';
  switch(level) {
    case 'PRO':
    case 'Pro':
      res = '职业';
      break;
    case 'E':
      res = 'D级助理';
      break;
    case 'GC':
      res = '守门员C级教练';
      break;
    case 'GB':
      res = '守门员B级教练';
      break;
    case 'GA':
      res = '守门员A级教练';
      break;
    case 'F1':
      res = '体能L1级教练';
      break;
    case 'F2':
      res = '体能L2级教练';
      break;
    default:
      res = level;
      break;
  }
  return res;
}

// 培训班等级
export function classLevelForNewUser(level) {
  let res = '';
  switch(level) {
    case 'PRO':
    case 'Pro':
      res = '职业级';
      break;
    case 'E':
      res = 'D级助理';
      break;
    case 'GC':
      res = '守门员C级教练';
      break;
    case 'GB':
      res = '守门员B级教练';
      break;
    case 'GA':
      res = '守门员A级教练';
      break;
    case 'F1':
      res = '体能L1级教练';
      break;
    case 'F2':
      res = '体能L2级教练';
      break;
    default:
      res = `${level}级`;
      break;
  }
  return res;
}

//报名类型
export function enroll_type(type) {
  let enroll_type = ''
  switch (type) {
    case "continue_education": enroll_type = '继续教育报名'; break
    case "common": enroll_type = '培训报名'; break
    case "make_up_exam": enroll_type = '补考报名'; break
    case "teacher_train": enroll_type = '讲师继续教育报名'; break
    case "goalkeeper_education": enroll_type = '守门员教练继续教育报名'; break
    case "physical_train": enroll_type = '体能教练员培训报名'; break
    case "goalkeeper_train": enroll_type = '守门员教练员培训报名'; break
    case "physical_make_up_exam": enroll_type = '体能教练员补考报名'; break
  }
  return enroll_type;
}

//报名培训类型
export function enroll_train_way(type) {
  let enroll_type = ''
  switch (type) {
    case "online": enroll_type = '线上'; break
    case "offline": enroll_type = '线下'; break
    case "online,offline": enroll_type = '线上+线下'; break
  }
  return enroll_type;
}
export function LevelFilters(type) {
  switch (type.toUpperCase()) {
    case '0': return '职业级'; break;
    case 'P': return '职业级'; break;
    case 'PRO': return '职业级'; break;
    case 'A': return 'A级'; break;
    case 'B': return 'B级'; break;
    case 'C': return 'C级'; break;
    case 'D': return 'D级'; break;
    case 'E': return 'D级助理'; break;
    case '初': return '初级'; break;
    case '中': return '中级'; break;
    case '高': return '高级'; break;
    case 'EARLY': return '初级'; break;
    case 'L1': return 'L1级'; break;
    case 'L2': return 'L2级'; break;
    case 'L3': return 'L3级'; break;
    case 'GC': return '守门员C级'; break;
    case 'GB': return '守门员B级'; break;
    case 'GA': return '守门员A级'; break;
    case 'F1': return '体能L1级'; break;
    case 'F2': return '体能L2级'; break;
    default: return '--'; break;
  }
}
export function LevelFiltersFutsal(type) {
   switch (type.toUpperCase()) {
    case '初': return '五人制足球初级教练员'; break;
    case 'L1': return '五人制足球L1级教练员'; break;
    case 'L2': return '五人制足球L2级教练员'; break;
    case 'L3': return '五人制足球L3级教练员'; break;
    case 'P': return '五人制足球职业级教练员'; break;
   
  }
}
export function typeFilters(type) {
  if(!type) return '--'
  switch (type) {
    case 'train': return '等级培训'; break;
    case 'continue_education': return '继续教育'; break;
    case 'teacher_train': return '讲师继续教育'; break;
    case 'goalkeeper_education': return '守门员教练继续教育'; break;
    case 'physical_train': return '体能教练员等级培训'; break;
    case 'goalkeeper_train': return '守门员教练等级培训'; break;

    default: return '--'
  }
}


export function train_type(type) {
  let train_type = '';
  switch (type) {
    case "level": train_type = '等级培训'; break;
    case "job": train_type = '岗位培训'; break;
    case "education": train_type = '继续教育'; break;
    case "international": train_type = '国际教练员资质认证'; break;
    case "futsal_level": train_type = '五人制等级教练员培训'; break;
  }
  return train_type;
}
export function NumberTypes(type) {
  let number_type = '中国居民身份证';
  switch (type) {
    case "id_number": number_type = '中国居民身份证'; break;
    case "idTypeCode_HMT": number_type = '港澳台居民居住证'; break;
    case "idTypeCode_wgjzz": number_type = '外国人永久居留身份证'; break;
    case "HM": number_type = '港澳居民来往内地通行证'; break;
    case "TAI": number_type = '台湾居民来往大陆通行证'; break;
    case "passport": number_type = '护照（仅国外教练员使用）'; break;
  }
  return number_type;
}


export const formationOfTeam = [
  {
    index: 0,
    key: '1-3-2-3-2',
    value: '1-3-2-3-2',
  },
  {
    index: 1,
    key: '1-3-2-4-1',
    value: '1-3-2-4-1',
  },
  {
    index: 2,
    key: '1-3-4-1-2',
    value: '1-3-4-1-2',
  },
  {
    index: 3,
    key: '1-3-4-2-1',
    value: '1-3-4-2-1',
  },
  {
    index: 4,
    key: '1-3-4-3',
    value: '1-3-4-3',
  },
  {
    index: 5,
    key: '1-3-5-2',
    value: '1-3-5-2',
  },
  {
    index: 6,
    key: '1-3-6-1',
    value: '1-3-6-1',
  },
  {
    index: 7,
    key: '1-4-1-2-3',
    value: '1-4-1-2-3',
  },
  {
    index: 8,
    key: '1-4-1-3-2',
    value: '1-4-1-3-2',
  },
  {
    index: 9,
    key: '1-4-1-4-1',
    value: '1-4-1-4-1',
  },
  {
    index: 10,
    key: '1-4-2-1-3',
    value: '1-4-2-1-3',
  },
  {
    index: 11,
    key: '1-4-2-3-1',
    value: '1-4-2-3-1',
  },
  {
    index: 12,
    key: '1-4-2-4-2',
    value: '1-4-2-4-2',
  },
  {
    index: 13,
    key: '1-4-3-1-2',
    value: '1-4-3-1-2',
  },
  {
    index: 14,
    key: '1-4-3-2-1',
    value: '1-4-3-2-1',
  },
  {
    index: 15,
    key: '1-4-3-3',
    value: '1-4-3-3',
  },
  {
    index: 16,
    key: '1-4-4-1-1',
    value: '1-4-4-1-1',
  },
  {
    index: 17,
    key: '1-4-4-2',
    value: '1-4-4-2',
  },
  {
    index: 18,
    key: '1-4-5-1',
    value: '1-4-5-1',
  },
  {
    index: 19,
    key: '1-5-2-1-2',
    value: '1-5-2-1-2',
  },
  {
    index: 20,
    key: '1-5-2-3',
    value: '1-5-2-3',
  },
  {
    index: 21,
    key: '1-5-3-1-1',
    value: '1-5-3-1-1',
  },
  {
    index: 22,
    key: '1-5-3-2',
    value: '1-5-3-2',
  },
  {
    index: 23,
    key: '1-5-4-1',
    value: '1-5-4-1',
  },
  {
    index: 24,
    key: '1-6-3-1',
    value: '1-6-3-1',
  },
  {
    index: 25,
    key: '其他(请手动输入)',
    value: '其他(请手动输入)',
  },
]

export const mainPosition = [
  // {
  //   index: 0,
  //   key: '守门员',
  //   value: '守门员',
  //   other: 'GK',
  // },
  {
    index: 1,
    key: '中后卫',
    value: '中后卫',
    other: '中后卫CB',
  },
  {
    index: 2,
    key: '左边后卫',
    value: '左边后卫',
    other: '左边后卫LB',
  },
  {
    index: 3,
    key: '右边后卫',
    value: '右边后卫',
    other: '右边后卫RB',
  },
  {
    index: 4,
    key: '防守型中场',
    value: '防守型中场',
    other: '防守型中场DMF',
  },
  {
    index: 5,
    key: '进攻型中场',
    value: '进攻型中场',
    other: '进攻型中场AMF',
  },
  {
    index: 6,
    key: '左边进攻中场',
    value: '左边进攻中场',
    other: '左边进攻中场LMF',
  },
  {
    index: 7,
    key: '右边进攻中场',
    value: '右边进攻中场',
    other: '右边进攻中场RMF',
  },
  {
    index: 8,
    key: '前锋',
    value: '前锋',
    other: '前锋ST',
  }
]
export const educationStatus = {
  "Initiated": {
    text: "继续教育未开始",
    color: '#00CCFF',
  },
  "Incomplete": {
    text: "继续教育进行中",
    color: '#0066FF'
  },
  "Finalised": {
    text: "继续教育已结束",
    color: '#00FF00'
  },
  "Complete": {
    text: "继续教育已完成",
    color: '#00FF00'
  },
}
export const learnStatus = {
  "Initiated": {
    text: "学习未开始",
    color: '#00CCFF',
  },
  "Incomplete": {
    text: "学习进行中",
    color: '#0066FF'
  },
  "Uncomplete": {
    text: "学习未完成",
    color: '#FF0000'
  },
  "Finalised": {
    text: "学习已结束",
    color: '#00FF00'
  },
  "Complete": {
    text: "学习已完成",
    color: '#00FF00'
  },
}
export function showScoreStatus(status) {
  switch (status) {
    case "pass": status = "通过"; break;
    case "fail": status = "未通过"; break;
    case "semi_pass": status = "预通过"; break;
    // case "practice_make_up": status = "实践课补考"; break;
    case "practice_make_up": status = " 实践考试补考"; break;
    case "theory_make_up": status = " 理论考试补考"; break;
    case "oral_make_up": status = " 口试补考"; break;
    default: status = ""; break;
  }
  return status;
}
